import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["focus"];

  connect() {
    this.element.addEventListener("shown.bs.modal", () => {
      this.focusTarget.focus();
    });
  }
}
